import { DamagedPartDescriptionModalProps } from '@/common/components/adjusterReport/damagedPoints/damagedPointsDescriptionModal/DamagedPointsDescriptionModal.type';
import { DamagedPartDescriptionQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/damagedPartDescription/damagedPartDescriptionQuery.type';
import { damagedPartDescriptionFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/damagedPartDescription/damagedPartDescriptionQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const useDamagedPartDescriptionQueryOptions = () => {
  return useMutation({
    mutationKey: ['DamagedPartDescription'],
    mutationFn: (
      params: DamagedPartDescriptionQueryParamsType &
        DamagedPartDescriptionModalProps,
    ) => damagedPartDescriptionFunction({ ...params, method: 'post' }),
  });
};
